import styled from 'styled-components';

export const ChatAreaContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.color.chatBorder};
  border-radius: 0.5rem;
  position: relative;
  background: ${({ theme }) => theme.color.chatBg};
`;
